import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import ModalListDevice from './ModalListDevice';
import { beeXLogger } from '../../helpers/logger';

const DeviceStateComponent = ({ data, mode }) => {
  console.log('🚀 ~ DeviceStateComponent ~ data:', data);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { namespace } = useSelector((state) => state);

  const [devices, setDevices] = useState({
    on: 0,
    off: 0,
    maintain: 0,
  });
  const [openModalListDevice, setOpenModalListDevice] = useState(false);
  const [deviceState, setDeviceState] = useState();

  const getStatisticDeviceStatus = (mode) => {
    const reqTime = new Date().getTime();
    let data = {
      deviceType: mode === 0 ? 'camera' : 'gateway',
      timeRequest: reqTime,
      namespace,
      isCache: 0,
    };
    console.log('🚀 ~ STATISTIC_DEVICE_STATUS ~ data:', data);
    let dataObj = {
      appServiceType: SERVICE.STATISTIC_DEVICE_STATUS,
      requestId: reqTime,
      body: JSON.stringify(data),
    };

    dispatch(socketEmitEvent(dataObj));
  };

  useEffect(() => {
    if (data) {
      setDevices({
        on: data.numberOnline || 0,
        off: data.numberOffline || 0,
        maintain: data.numberMaintain || 0,
      });
    }
  }, [data]);

  return (
    <div className="device-component">
      <div className="list-devices">
        <div className="device-count on">
          <Tooltip
            placement="leftTop"
            title={t('_COUNT DEVICE ONLINE_', {
              count: devices.on,
              deviceType: mode === 0 ? 'camera' : 'gateway',
            })}
          >
            <div
              className="count"
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                setDeviceState(1);
                setOpenModalListDevice(true);
                getStatisticDeviceStatus(mode);
              }}
            >
              {devices.on}
            </div>
            <div className="statement">{t('Online')}</div>
          </Tooltip>
        </div>
        <div className="device-count off">
          <Tooltip
            placement="leftTop"
            title={t('_COUNT DEVICE OFFLINE_', {
              count: devices.off,
              deviceType: mode === 0 ? 'camera' : 'gateway',
            })}
          >
            <div
              className="count"
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                setDeviceState(0);
                setOpenModalListDevice(true);
                getStatisticDeviceStatus(mode);
              }}
            >
              {devices.off}
            </div>
            <div className="statement">{t('Offline')}</div>
          </Tooltip>
        </div>
        <div className="device-count maintain">
          <Tooltip
            placement="leftTop"
            title={t('_COUNT DEVICE MAINTAIN_', {
              count: devices.maintain,
              deviceType: mode === 0 ? 'camera' : 'gateway',
            })}
          >
            <div
              className="count"
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                setDeviceState(2);
                setOpenModalListDevice(true);
                getStatisticDeviceStatus(mode);
              }}
            >
              {devices.maintain}
            </div>
            <div className="statement">{t('Maintain')}</div>
          </Tooltip>
        </div>
      </div>
      {openModalListDevice && (
        <ModalListDevice
          mode={mode}
          deviceState={deviceState}
          open={openModalListDevice}
          onClose={() => setOpenModalListDevice(false)}
        />
      )}
    </div>
  );
};

export default DeviceStateComponent;
